let cachedAuthAPI: any | null = null;
let authAPILoadPromise: Promise<any> | null = null;

export const getAuthAPI = async () => {
  if (cachedAuthAPI) {
    return cachedAuthAPI;
  }

  if (!authAPILoadPromise) {
    authAPILoadPromise = import(
      /* webpackMode: "eager" */ 'shared/api/authResolver'
    ).then(({ AuthAPI }) => {
      cachedAuthAPI = AuthAPI;
      return cachedAuthAPI;
    });
  }

  return authAPILoadPromise;
};
